export enum TabItemValue {
    General = 'General',
    Address = 'Address',
    Documents = 'Documents',
    GuestVerification = 'GuestVerification',
}
